import "./Story.module.css";
import Header from "@/reusable_sections/Header";
import CompanyMission from "./sections/CompanyMission";
import TheMindsBehindServa from "./sections/TheMindsBehindServa";
import WhyHabeshaPastry from "./sections/WhyHabeshaPastry";
import Footer from "@/reusable_sections/Footer";
export default function StoryPage() {
  return <div>
      <Header />
      <CompanyMission />
      <TheMindsBehindServa />
      <WhyHabeshaPastry />
      <Footer />
    </div>;
}